import { useEffect } from 'react'

/** Ist das eine HLS-Quelle (Bunny Stream)? MP4 vom eigenen Server ist es nicht. */
export const isHlsType = type => /mpegurl/i.test(type || '')

/**
 * Hängt eine HLS-Quelle an ein vorhandenes `<video>`.
 *
 * Bunny liefert die Kursvideos als HLS (Playlist mit Stufen von 240p bis
 * 1080p, die sich der Leitung anpassen). Safari und iOS spielen das selbst ab,
 * Chrome und Firefox am Schreibtisch nicht — dort übernimmt hls.js. Wichtig
 * ist, dass es **dasselbe Element** bleibt: An ihm hängen Fortsetzen
 * (`loadedmetadata`) und die Fortschrittsmeldung (`timeupdate`, `pause`,
 * `ended`), und damit die Regel „Vorspulen zählt nicht".
 *
 * hls.js wird erst geladen, wenn es gebraucht wird; MP4-Videos und Safari
 * kommen ohne die Bibliothek aus.
 *
 * Für MP4 tut der Haken nichts — dort steht die Adresse weiter im `src`.
 */
export default function useVideoSource(videoRef, url, type) {
	useEffect(() => {
		const video = videoRef.current
		if (!video || !url || !isHlsType(type)) return undefined

		if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = url
			return () => {
				video.removeAttribute('src')
			}
		}

		let aktiv = true
		let hls = null
		import('hls.js').then(({ default: Hls }) => {
			if (!aktiv) return
			if (!Hls.isSupported()) {
				video.src = url
				return
			}
			hls = new Hls()
			hls.loadSource(url)
			hls.attachMedia(video)
		})

		return () => {
			aktiv = false
			if (hls) hls.destroy()
		}
	}, [videoRef, url, type])
}
